module.exports = __webpack_public_path__ + "static/media/wayptback.b9ad0809.png";